import { __assign } from './../../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
import Typography from '../../../../Atoms/Typography.js';
import LazyImage from '../../../../Atoms/LazyImage.js';
import CommaIcon from '../../../../assets/icons/comma.icon.js';
import Icon from './../../../../external_lib/@ant-design/icons/es/components/Icon.js';

function TestimonialThreeCard(_a) {
    var name = _a.name, designation = _a.designation, quote = _a.quote, image = _a.image, ratings = _a.ratings, imageComponent = _a.imageComponent;
    var Comma = function (props) { return React__default.createElement(Icon, __assign({ component: CommaIcon }, props)); };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(LazyImage, { alt: "testimonial-three-card-image", src: image, classes: "testimonial-three-card-image", imageComponent: imageComponent }),
        React__default.createElement(Typography, { weight: "semibold", classes: "testimonial-three-card-name", variant: 'headingTwo' }, name),
        React__default.createElement(Typography, { classes: "testimonial-three-card-designation", variant: 'bodyTextOne' }, designation),
        React__default.createElement("div", { className: "testimonial-three-card-ratings" }, ratings
            ? new Array(ratings)
                .fill(0)
                .map(function (_, index) { return React__default.createElement("div", { key: index }, "\u2B50"); })
            : null),
        React__default.createElement(Typography, { classes: "testimonial-three-card-quote", variant: 'bodyTextOne' }, quote),
        React__default.createElement("div", { className: "testimonial-three-card-commas" },
            React__default.createElement(Comma, { className: "testimonial-three-card-comma" }),
            React__default.createElement(Comma, { className: "testimonial-three-card-comma" }))));
}

export { TestimonialThreeCard as default };
//# sourceMappingURL=testimonial-three-card.component.js.map
